import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${backendUrl}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("coi_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg).join(" ");
  }
  return detail || "Something went wrong. Please try again.";
}

export function saveSession(session) {
  localStorage.setItem("coi_access_token", session.accessToken);
  localStorage.setItem("coi_refresh_token", session.refreshToken);
}

export function clearSession() {
  localStorage.removeItem("coi_access_token");
  localStorage.removeItem("coi_refresh_token");
}